import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { BootcampLevelStat } from '~/redux/apis/user-stats-api'

import LevelInfo from '../LevelInfo'

import ActivitySet from './ActivitySet'

interface Props {
  id: string
  activitySets: BootcampLevelStat['activitySets']
  name: string
  levelNo: number
  isCompleted?: boolean
  locale?: string | undefined
}

export default function LevelStat({
  id,
  activitySets,
  name = '',
  levelNo,
  isCompleted = false,
  locale,
}: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const onRetakeBtnClick = function (setNumber: number): void {
    statisticsAnalytics.logRetakeButtonClick({ name, setNumber })
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <LevelInfo levelNo={levelNo} name={name} />
        {isCompleted && <SVGImage enhanceQuality srcKey="scoreboard/checkmark-v2.svg" width={20} />}
      </div>

      {activitySets && Object.keys(activitySets).length > 0 && (
        <div className="py-2">
          <p className="font-medium">{t('activity-sets')}</p>
          {Object.entries(activitySets).map(
            ([
              setNo,
              { activityPath, completedChestsCount, chestsCount, correctAnswers, incorrectAnswers, retakeRound },
            ]) => {
              const correctPercentage = Math.floor((correctAnswers / (correctAnswers + incorrectAnswers)) * 100)
              const setCompletionPercentage = Math.floor((completedChestsCount / chestsCount) * 100)
              const formatCorrectPercentage = isNaN(correctPercentage) ? 0 : correctPercentage
              const formatSetCompletionPercentage = isNaN(setCompletionPercentage) ? 0 : setCompletionPercentage

              return (
                <ActivitySet
                  activityPath={activityPath}
                  correctPercentage={formatCorrectPercentage}
                  id={id}
                  key={setNo}
                  levelNo={levelNo}
                  locale={locale}
                  retakeBtnClick={onRetakeBtnClick}
                  retakeRound={retakeRound}
                  setCompletionPercentage={formatSetCompletionPercentage}
                  setNo={Number(setNo)}
                />
              )
            },
          )}
        </div>
      )}

      <div className="my-4 w-full h-0.5 bg-purple-light" />
    </div>
  )
}
